import { tryCatch } from '@/lib/try-catch'
import {
  deleteMomentTagsAndEmotionsPayloadById,
  getMomentTagsAndEmotionsPayload,
} from '@/local-db/moment-tags-and-emotions'
import { vanillaApiClient } from '@/trpc/vanilla'

const onError = async ({
  error,
  id,
  message,
}: {
  error: Error
  id: number
  message: string
}) => {
  console.error(message, error)
  return await deleteMomentTagsAndEmotionsPayloadById(id)
}

export const generateAndSaveTagsAndEmotion = async () => {
  const payloads = await getMomentTagsAndEmotionsPayload()
  for (const payload of payloads) {
    const { error: generateError } = await tryCatch(
      vanillaApiClient.moments.generateAndSaveTagsAndEmotion.mutate({
        content: payload.content,
        id: payload.momentId,
      }),
    )

    if (generateError) {
      return onError({
        id: payload.id,
        error: generateError,
        message: 'Error generating tags and emotions',
      })
    }

    await deleteMomentTagsAndEmotionsPayloadById(payload.id)
  }
}
